export default __webpack_public_path__ + "static/media/isobar.57ed05ce.svg";